/*
 * @author : Augusto Monteiro
 * @email  : augustomna2010@gmail.com
 * @augustomna2010 
 */


Monet.UI = Monet.UI || {};

Monet.UI.QuickColorsFilter = (function () {
    

    function QuickColorsFilter () {

        this.rootEl = document.createElement("div");
        this.allColor = "#c0bfbf";
        this.colors = [];
        this.totalColors = 0;
        this.showPercents = true;
        this.totalEl = null;
        this.countsEl = {};
        this.activeColors = [];
        this.listenner = null;

        this.executeListeners = function () {
            if (this.listener) {
                this.listener();
            }
        };

        this.setActionListener = function (listener) {
            this.listener = listener;
        };

        this.setColors = function (colors) {
            this.colors = colors;
        };

        this.getColors = function () {
            return this.activeColors;
        };

        this.renderTitle = function () {
            var title = document.createElement("div");
            title.className = "QuickColorsTitle";
            title.innerHTML = Monet.I18n.getResourcesByKey("");
        };

        this.calculePercent = function (value, total) {
            return Math.round((!total || !value) ? 0 : ((value / total) * 100));
        };

        this.renderTotalsEl = function (color, total, totalPercentValue) {
            var totalEl      = document.createElement("span"),
                totalNumber  = document.createElement("span"),
                totalPercent = null;

            totalEl.className = "QuickColorsFilterShowTotals";

            totalNumber.innerHTML = total;

            totalEl.appendChild(totalNumber);

            totalPercent = document.createElement("span");
            totalPercent.innerHTML = totalPercentValue;
            totalEl.appendChild(totalPercent);

            this.countsEl[color] = {
                number: totalNumber,
                percent: totalPercent
            };

            return totalEl;
        };

        this.updateCounts = function (colors) {
            var percentText = null,
                el          = null;

            this.colors = colors;

            if (colors) {

                this.totalColors = this.calculaleTotal();

                this.countsEl["ALL"].number.innerHTML = this.totalColors;

                colors.forEach(function (color) {
                    el = this.countsEl[color.color];
                    el.number.innerHTML = color.total;
                    if (this.showPercents) {
                        el.percent.innerHTML = percentText = "(" + this.calculePercent(color.total, this.totalColors) + "%)";
                    }
                }.bind(this));

            }
        };

        this.renderTotals = function (color, total) {
            var percentText = "";
            if (this.showPercents) {
                percentText = "(" + this.calculePercent(total, this.totalColors) + "%)";
            }
            return this.renderTotalsEl(color, total, percentText);
        };

        this.onClickColor = function (scope, colorEl, color) {
            return function () {
                scope.toggleActiveColor(colorEl, color);
                scope.executeListeners();
            };
        };

        this.removeAllAtivesCss = () => {
            var nodes = this.rootEl.childNodes;
            for (var i = 0, len = nodes.length; i < len; i++) {
                nodes[i].className = nodes[i].className.replace("active", "").trim();
            }
        };

        this.toggleActiveColor = function (colorEl, color) {
            this.activeColors = [];

            const isToFlip = this.rootEl.querySelector('.active').getAttribute('flip') == "true";
            this.removeAllAtivesCss();

            colorEl.setAttribute("flip", !isToFlip);
            colorEl.className += " active";
            this.activeColors.push(color);
        };

        this.createColorItemEl = function (color) {
            var item = document.createElement("div");
            item.className = "QuickColorsFilterItem";

            var colorEl = document.createElement("span");
            colorEl.className = "QuickColorsFilterItemColor";
            colorEl.style.backgroundColor = color;

            item.appendChild(colorEl);

            return item;
        };

        this.renderShowAll = function () {
            var item = this.createColorItemEl(this.allColor);

            item.className += " active";

            item.addEventListener("click", function () {
                this.activeColors = [];
                this.removeAllAtivesCss();
                item.className += " active";
                this.executeListeners();
            }.bind(this));

            item.appendChild(this.renderTotalsEl('ALL', this.totalColors, Monet.I18n.getResourcesByKey("total")));

            this.totalEl = item;
            this.rootEl.appendChild(item);
        };

        this.renderColorItem = function (color) {

            var item = this.createColorItemEl(color.color);

            item.addEventListener("click", this.onClickColor(this, item, color.color));

            item.title = color.title || "";

            item.appendChild(this.renderTotals(color.color, color.total));

            this.rootEl.appendChild(item);
        };

        this.calculaleTotal = function () {
            return this.colors.reduce(function (i, color) {
                return i + color.total;
            }, 0);
        };

        this.renderColors = function () {
            this.colors.forEach(function (color) {
                this.renderColorItem(color);
            }.bind(this));
        };

        this.renderTitle = function (title) {
            var span = document.createElement("span");
            span.className = "QuickColorsFilterTitle";
            span.innerHTML = Monet.I18n.getResourcesByKey(title) + ":";
            this.rootEl.appendChild(span);
        };

        this.render = function (title, colors, total) {

            if (!title || !colors) {
                throw new Error("Colors and Title are required");
            }

            this.renderTitle(title);
            this.setColors(colors);

            this.totalColors = total;

            if (!total) {
                this.totalColors = this.calculaleTotal();
            }

            this.renderShowAll();
            this.renderColors();

            this.rootEl.className = "QuickColorsFilter";

            return this.rootEl;
        };

    };

    return QuickColorsFilter;

})();
